module.exports = __webpack_public_path__ + "img/slide_001_h5.c7777514.jpg";